import { z } from 'zod';
import { OptionsSchema as BaseOptionsSchema, AuiTokenSchema } from '../../WidgetVariant/types';

const BumperHeaderSchema = z.object({
  collapsedTitle: z.string().optional(),
  expandedTitle: z.string().optional(),
  showStarRating: z.boolean().optional(),
});

const TopicSchema = z.object({
  auiIcon: z.string().optional(),
  text: z.string(),
});

const DisplayModesSchema = z.enum(['COLLAPSED', 'EXPANDED', 'HIDDEN']);
export const ShowActionDisplayModeSchema = DisplayModesSchema.exclude(['HIDDEN']);
export type ShowActionDisplayModes = z.infer<typeof ShowActionDisplayModeSchema>;

const BumperBaseSchema = z.object({
  bumperHeader: BumperHeaderSchema.optional(),
  callbackConfirmationImg: z
    .object({
      alt: z.string().optional(),
      src: z.string(),
    })
    .optional(),
  chatLogo: z
    .object({
      alt: z.string().optional(),
      src: z.string(),
    })
    .optional(),
  chatPanelTextInputLabel: z.string().optional(),
  defaultOpened: z.boolean().optional(),
  landingPanelTitle: z.string().optional(),
  logo: z.object({
    alt: z.string().optional(),
    src: z.string(),
  }),
  topics: z.array(TopicSchema),
});

const BumperSchema = BumperBaseSchema.merge(AuiTokenSchema);

export const OptionsSchema = BaseOptionsSchema.extend({
  bumper: BumperSchema,
});

export const PartialOptionsSchema = BaseOptionsSchema.extend({
  bumper: BumperSchema.partial(),
}).partial();

export type BumperHeader = z.infer<typeof BumperHeaderSchema>;
export type Topic = z.infer<typeof TopicSchema>;
export type Options = z.infer<typeof OptionsSchema>;
export type PartialOptions = z.infer<typeof PartialOptionsSchema>;
